import {NextPage} from "next";
import Head from "next/head";
import {wrapper} from "../../app/store";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {PromptsView} from "../../components/prompt/PromptsView";

const Prompts: NextPage = () => {
  return <>
    <Head>
      <title>Prompts</title>
    </Head>
    <PromptsView />
  </>
}

export const getStaticProps = wrapper.getStaticProps(store => async ({ locale }: any) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common', 'landing', 'auth', 'location', 'store', 'payment', 'checkout', 'order', 'affiliate']),
    }
  }
});


export default Prompts